import { render, staticRenderFns } from "./AuthorsTag.vue?vue&type=template&id=f1325414"
import script from "./AuthorsTag.vue?vue&type=script&lang=js"
export * from "./AuthorsTag.vue?vue&type=script&lang=js"
import style0 from "./AuthorsTag.vue?vue&type=style&index=0&id=f1325414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports